// extracted by mini-css-extract-plugin
export default {"pageWrap":"gd-z","fullWidth":"hd-z","heading":"id-z","fullBleed":"jd-z","hidden":"kd-z"};